import { autoinject, transient, useView } from "aurelia-framework";
import { ClientSideValidator, EntityValidationsService } from "../../../../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../../../../client-validation-system/validations.models";
import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from "../../../../../../models/basics/basics.models";
import { LookupValue } from "../../../../../../models/lookups/lookup.models";
import { ManageVesselService } from "../../../../../../services/vessels/manage-vessel.service";
import { EntityFinderSearch } from "../../../../../components/entity-finder/entity-finder-search";
import { BaseVetOrder } from "../base-vet-order";
import * as moment from "moment";
import { OrderModel } from "../../../../../../models/rightstore/rightstore.models";

@autoinject()
@transient()
@useView('views/pages/modules/orders/plugins/pre-arrival-check/pre-arrival-check.html')
export class PreArrivalCheck extends BaseVetOrder {

    vesselVM: EntityFinderSearch;
    arrivalPortId: number;
    arrivalDate: string | Date;
    arrivalTime: string | Date;
    cargoTypeId: number;
    cargoTypeValue: LookupValue;
    public vesselEntityTypes: EntityTypeConfigurationModel[];
    public portEntityTypes: EntityTypeConfigurationModel[];
    validator: ClientSideValidator;
    public canSubmit: boolean = true;

    public get disableSubmitInternal(): boolean {
        return false;
    }

    activate(params: { vesselId: number, order: OrderModel, viewTitle: string }) {
        this.vesselId = params.vesselId;
        this.canEditVessel = !params.vesselId || params.order?.orderGuid != null;
        if (params.viewTitle != null && params.viewTitle != "") this.viewTitle = params.viewTitle;
    }

    attached() {
        if (this.vesselId) {
            this.vesselVM.set({ entityTypeUri: this.vesselEntityTypes[0].uri, id: this.vesselId }).then(() => {
                this.setVessel(this.vesselVM.selectedEntity);
            });
        }
    }

    viewTitle: string = "Pre-Arrival Check";

    constructor(protected vesselService: ManageVesselService, private entityValidationsService: EntityValidationsService,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper) {
        super(vesselService);
        this.vesselEntityTypes = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions(["VesselSearch"]).filter(x => x.key == "BasicVesselSearch");
        this.portEntityTypes = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions(["Ports"]);
    }

    public onArrivalPortSelected(port) {
        this.arrivalPortId = port ? port.id : null;
    }

    private setValidator() {
        const rules = [
            {
                errorMessage: "Arrival Port is required",
                parameters: null, property: "arrivalPortId",
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: "Vessel Name / IMO is required",
                parameters: null, property: "vesselId",
                validationType: ValidationTypeEnum.Required
            }];

        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Screening Request",
            isCollection: false,
            nestedRulesHolder: [],
            rules: rules
        };

        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    }

    public async isValid(): Promise<boolean> {
        this.setValidator();
        return await this.validator.validate().then(x => {
            return x.valid
        });
    }

    public getMetaModel() {
        const arrivalDateTime = this.arrivalDate ? moment(this.arrivalDate).set("hour", moment(this.arrivalTime).hours()).set("minute", moment(this.arrivalTime).minutes()) : null;
        const metaModel = {
            vesselId: this.vesselId,
            portToId: this.arrivalPortId,
            arrivalDate: arrivalDateTime,
            arrivalTime: this.arrivalTime,
            cargoTypeId: this.cargoTypeId
        };

        return metaModel;
    }
}